import React, { FC, ReactNode } from "react";
import {
  ActionLink,
  Actions,
  Body,
  Container,
  Content,
  IconSlot,
  Title,
  V3CalloutTone,
} from "./Callout.styled";

export type { V3CalloutTone };

export interface V3CalloutAction {
  label: string;
  onClick: () => void;
  testID?: string;
}

export interface V3CalloutProps {
  tone: V3CalloutTone;
  /** The design-system fill and primary body text, for a callout that blocks the step. */
  solid?: boolean;
  /** Text actions under the message, as on the mobile callout. */
  actions?: V3CalloutAction[];
  title?: string;
  icon?: ReactNode;
  children: ReactNode;
  /** "alert" for a message that appears after an action, so it is announced. */
  role?: "note" | "alert";
  testID?: string;
}

export const V3Callout: FC<V3CalloutProps> = ({
  tone,
  solid = false,
  actions,
  title,
  icon,
  children,
  role = "note",
  testID,
}) => (
  <Container $tone={tone} $solid={solid} role={role} data-testid={testID}>
    {icon ? (
      <IconSlot $tone={tone} aria-hidden="true">
        {icon}
      </IconSlot>
    ) : null}
    <Content>
      {title ? <Title $tone={tone}>{title}</Title> : null}
      <Body $solid={solid}>{children}</Body>
      {actions && actions.length > 0 ? (
        <Actions>
          {actions.map((action) => (
            <ActionLink
              key={action.label}
              type="button"
              $tone={tone}
              onClick={action.onClick}
              data-testid={action.testID}
            >
              {action.label}
            </ActionLink>
          ))}
        </Actions>
      ) : null}
    </Content>
  </Container>
);
